/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import ParticipantsPage from './participants.page';
import { withRouter } from 'react-router-dom';
import { publishParticipantsStudyGid } from '../../actions/actions';
import { fetchAssignments } from '../../actions/rolemanagement.actions';
export const mapStateToProps = (state, ownProps) => {
  return {
    isStudyGidSet: !!state.participants.studyGid,
    study: state.subject.participantStudy,
    sponsor: state.sponsor.selectedSponsor,
    user: state.login.user
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    publishParticipantsStudyGid: (studyGid) => {
      dispatch(publishParticipantsStudyGid(studyGid));
    }
  };
};

const ParticipantsPageContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantsPage));

export default ParticipantsPageContainer;
